module.exports = __webpack_public_path__ + "static/media/Elevation-2.ad0093cb.webp";